var objTicketActivities = {
    // <summary>
    // This object holds all functions for activity related functionality in ticket.js
    // </summary>


    _loadActivityForm: function (me) {
        /// <summary>
        ///  This function loads the activity form for the given ticket
        /// </summary>

        try {
            if (me.error) { return false; }
            const actDivId = "divActivities_" + me.vcgid;

            me.myHtml.rowActivities.wrapper.show();
            if (me.entry.Id == -1) {
                const div = me.fnd(".ticket-activities");
                div.empty().html( $("<div>").addClass("note").html(me.specific.resources.saveBeforeEdit) );
                return true;
            }


            //TODO: MKU - CHANGE ACTIVITIES HERE - showOverview = false, optional billing/accounting mode, ticket, all user,
            var div = me.fnd(".ticket-activities");
            var old = div.find("#" + actDivId);
            if (old.length) {
                try {
                    old.Activities("destroy");
                } catch (ex) {
                    me._writeErr(ex);
                }
            }

            div.empty();
            var actRoot = $("<div>").attr("id", actDivId).width(me.myHtml.rowActivities.wrapper.width());

            if (me.specific.print) {
                actRoot.css("height", "auto");
            } else {
                actRoot.height(me.myHtml.rowActivities.wrapper.height());
            }

            div.append(actRoot);


            var bEditable = !me.specific.readOnlyMode;
            // simple edit mode users (restricted rights) can still add activities if they have hasEditRight
            if (bEditable && me.specific.simpleEditMode) bEditable = !!me.specific.hasEditRight;
            actRoot.Activities({ invokeType: "addVisualBase", parameter: { TicketId: me.entry.Id, LoggerId: me.entry.Blid, Editable: bEditable, ShowOverview: false, StartWithOverview: false, isSeen: false, BillingMode: me.specific.accountingMode, TimeRange: 5, HideDateBox: true, PermanentTicket: me.entry.Data.State == 6 ? true : false, OrderNumber: encodeURIComponent(me.entry.Data.Order || "") } });
            //me.vcV.addVisualBaseByName('div', 'VISUAL_FORM_ACTIVITY', 'Activities' + me.vcgid, getCurrentTimestamp(), parseInt(me.myHtml.rowActivities.wrapper.height()), parseInt(me.myHtml.rowActivities.wrapper.width()), me.entry.Blid + "," + me.entry.Id, "", 1);

            if (!me.lastBilling) {
                me.lastBilling = false;
            }

            // listener for billing filter changes (permanent tickets)
            actRoot.off("activities:lastBillingChanged").on("activities:lastBillingChanged", function (e, payload) {
                const isLast = !!(payload && typeof payload.filter !== "undefined" ? payload.filter : false);
                me.lastBilling = isLast;

                const ticketId = me.entry && me.entry.Id ? me.entry.Id : me.specific && me.specific.ticketId;
                if (ticketId && window.localStorage) {
                    const key = "ticketLastBilling_" + ticketId;
                    localStorage.setItem(key, isLast ? "true" : "false");
                }

                if (me.specific.readOnlyMode) {
                    objTicketActivities._fetchActivities(me);
                }
            });


            actRoot.off("activities:selectedChanged").on("activities:selectedChanged", function (e, payload) {
                try {
                    const ids = (payload && Array.isArray(payload.ids)) ? payload.ids : [];
                    me.selectedActivityIdsForPrint = ids;

                    const ticketId = me.entry && me.entry.Id ? me.entry.Id : (me.specific && me.specific.ticketId);
                    if (ticketId && window.localStorage) {
                        const key = "ticketSelectedActivities_" + ticketId;
                        localStorage.setItem(key, JSON.stringify(ids));
                    }
                } catch (ex) { me._writeErr(ex); }
            });

            actRoot.off("activities:printSelectedRequested").on("activities:printSelectedRequested", function (e, payload) {
                try {
                    // request from activity widget to print selected activities
                    me._openPrintActivities();
                } catch (ex) { me._writeErr(ex); }
            });

        } catch (ex) { me._writeErr(ex);}

    },

    _fetchActivities: function (me) {
        /// <summary>
        ///  This function fetches the activities for the given ticket
        /// </summary>
       
        try {
            if (me.error) { return false; }
            if (!me.specific.readOnlyMode) return true;


            const isPermanent = me.entry && me.entry.Data && (me.entry.Data.State == 6);
            let lastBilling = false;

            if (typeof me.lastBilling === "boolean") {
                lastBilling = me.lastBilling;
            }

            // we get the lastBilling setting from session storage
            const ticketId = me.specific && me.specific.ticketId;
            if (ticketId && window.localStorage) {
                const key = "ticketLastBilling_" + ticketId;
                const stored = localStorage.getItem(key);
                if (stored !== null) {
                    lastBilling = (stored === "true");
                }
            }

            // we get the selected activity ids from session storage (from objActivityList.js)
            let selectedIds = [];
            if (ticketId && window.localStorage && me.specific.accountingMode) {
                const keySel = "ticketSelectedActivities_" + ticketId;
                const raw = localStorage.getItem(keySel);
                if (raw) {
                    try { selectedIds = JSON.parse(raw) || []; } catch (e) { selectedIds = []; }
                }
            }

            me.getData({ TypeId: 8, 'TicketID': me.specific.ticketId, PermanentTicket: isPermanent, LastBilling: lastBilling, SelectedActivityIds: selectedIds }, function (result) {             
                if (result === null) { me.showMessage(me.resources.err_loadData, true); return false; }

                if (result.length == 0) {
                    me.fnd('#divActivities' + me.vcgid).html("").hide();
                    return true;
                }

                me.activitiesData = result;

                objTicketActivities._fillActivities(me, result);
                me.myHtml.rowActivities.wrapper.show();                

                return true;
            });
            return true;
        } catch (ex) { me._writeErr(ex); return false }

    },

    _fillActivities: function (me, data) {
        /// <summary>
        ///  This function generates a vc-list for all data entries 
        /// </summary>
        var item;
        var ul;
       
        try {
            if (me.error) { return false; }

            var showOrderNo = !!(me.specific.print);

            // if we show the order no in the filtered print, we show all order no which exists
            if (showOrderNo) {
                let orderNosText = "";
                const set = new Set();

                for (let x = 0; x < data.length; x++) {
                    const v = (data[x].OrderNo ?? data[x].orderNo ?? "").toString().trim();
                    if (v) set.add(v);
                }

                const arr = Array.from(set);
                arr.sort((a, b) => a.localeCompare(b, 'de'));

                orderNosText = arr.join(", ");

                me.myHtml.topMenu.orderNo.html( "<i class='fa-regular fa-note'></i> " + me.specific.resources.orderNumber + ": " + (orderNosText.length ? orderNosText : "&nbsp;") );
            }
           
            if (data.length == 0) {
                me.fnd('#divActivities' + me.vcgid).html("").hide();
                return true;
            }

            ul = $("<ul>").attr("id", "lst-activities").addClass("vc-list vc-list-table");

            if (me.specific.print) {
                ul.css("height", "auto").css("overflow", "visible");
            } else {
                ul.css("height", me.myHtml.rowActivities.wrapper.height()).css("overflow", "auto");
            }

            var line = me._setListItem();
            line.column.append(me._setListElement("", "w7 smaller").html("<b>" + me.specific.resources.date + "</b>"));
            line.column.append(me._setListElement("", "w5 smaller").html("<b>" + me.specific.resources.time + "</b>"));
            //line.column.append(me._setListElement("", "w7 text-right").html("<b>" + me.specific.resources.public + "</b>"));
            line.column.append(me._setListElement("", "w6 text-right smaller").html("<b>" + me.specific.resources.duration + "</br> (h)" + "</b>"));         

            if (me.specific.accountingMode) {
                line.column.append(me._setListElement("", "w7 text-right smaller").html("<b>" + me.specific.resources.accounting +"</b>"));
            }

            if (showOrderNo) {
                line.column.append(me._setListElement("", "w11 text-right smaller").html("<b>" + me.specific.resources.orderNumber + "</b>"));
                line.column.append(me._setListElement("", "w6 text-right smaller").html("<b>" + me.specific.resources.orderType + "</b>"));
            }

            line.column.append(me._setListElement("", "w6 text-right smaller").html("<b>" + me.specific.resources.internal + "</b>"));            

            line.column.append(me._setListElement("", "w4 text-right smaller").html("<b>" + me.specific.resources.km + "</b>"));
            line.column.append(me._setListElement("", "w5 text-right smaller").html("<b>" + me.specific.resources.travel + "</br> (h)" + "</b>"));
            line.column.append(me._setListElement("", "w10 vc-grid-margin-left smaller").html("<b>" + me.specific.resources.user + "</b>"));
            line.column.append(me._setListElement("", me.specific.accountingMode ? "w25 smaller" : "w25 smaller").html("<b>" + me.specific.resources.description + "</b>"));

            ul.append(line.item);

            var dSumC=0, dSum=0, dKm=0, dArrival = 0, dBill=0;


            for (i = 0; i < data.length; i++) {
                var line = me._setListItem();

                //line.column.append(me._setListElement("", "w9 smaller").html(moment(data[i].Date, "DD.MM.YYYY HH:mm:ss").toDate().format("dd.MM.yyyy")));

                // build dd.mm. + yyyy in two lines
                let dText = "";
                try {
                    const d = moment(data[i].Date, "DD.MM.YYYY HH:mm:ss").toDate();
                    const formatted = d.format("dd.MM.yyyy"); 
                    const parts = String(formatted || "").split(".");
                    if (parts.length === 3) {
                        const firstLine = parts[0] + "." + parts[1] + ".";
                        const year = parts[2];
                        dText = `<span class="date-billing-wrap">${firstLine}<br/>${year}</span>`;
                    } else {
                        dText = formatted;
                    }
                } catch (e) {
                    dText = "&nbsp;";
                }

                line.column.append(me._setListElement("", "w7 smaller").html(dText));


                //line.column.append(me._setListElement("", "w5").html(data[i].StartTime + " - " + data[i].EndTime));
                line.column.append(me._setListElement("", "w5 smaller").html(data[i].StartTime + "<br/>" + data[i].EndTime));
               
                //if (data[i].IsPublic) {
                //    line.column.append(me._setListElement("", "w8 text-right").html("<i class='fa fa-eye icon-color-info'></i>"));
                //} else {
                //    line.column.append(me._setListElement("", "w8 text-right").html("fa fa-ban icon-color-error"));
                //}

                var durVal = data[i].IsChargeable ? data[i].Duration : 0;
                var intVal = data[i].IsChargeable ? 0 : data[i].Duration;

                line.column.append(me._setListElement("", "w6 text-right smaller").html(durVal));
                

                if (me.specific.accountingMode) {
                    const billedRaw = data[i].Billingtime;
                    let billedText = "";
                    if (billedRaw !== null && billedRaw !== undefined && !isNaN(Number(billedRaw))) {
                        const billedNum = Number(billedRaw);

                        if (billedNum !== -1) { // if no billing time is set yet, we get -1 (= null in DB)
                            billedText = (Math.round(billedNum * 100) / 100).toFixed(2);
                            dBill += billedNum; // we only sum real billing times
                        }
                        else 
                            billedText = "&nbsp;"; // placeholder for empty billing time
                        
                    }
                    line.column.append(me._setListElement("", "w7 text-right smaller").html(billedText));
                }

                if (showOrderNo) {                    
                    var orderNo = (data[i].OrderNo || data[i].orderNo || "").toString();
                    var orderTypeID = (data[i].OrderTypeID || data[i].OrderTypeID || "").toString();
                    var orderType = objTicketActivities._orderTypeNameById(me, orderTypeID);

                    line.column.append(me._setListElement("", "w11 text-left-margin smaller").html(orderNo.length ? orderNo : "&nbsp;"));
                    line.column.append(me._setListElement("", "w6 text-right smaller").html(orderType.length ? orderType : "&nbsp;"));
                }

                line.column.append(me._setListElement("", "w6 text-right smaller").html(intVal));


                if (data[i].IsChargeable) {
                    dSumC += data[i].Duration;
                } else {
                    dSum += data[i].Duration;
                }    

                
             
                line.column.append(me._setListElement("", "w4 text-right smaller").html(data[i].Km));
                line.column.append(me._setListElement("", "w5 text-right smaller").html(data[i].Arrival));
                dKm += data[i].Km;
                dArrival += data[i].Arrival;

                const shortName = objTicketActivities._buildShortUserCode(data[i].UserName);
                line.column.append(me._setListElement("", "w10 vc-grid-margin-left smaller").html(shortName));

                line.column.append(me._setListElement("", me.specific.accountingMode ? "w25 smaller" : "w25 smaller").html(data[i].Description));
                ul.append(line.item);

            }

            me.myHtml.rowActivities.wrapper.html(ul);
            ul.find(".vc-list-item").removeClass("alt").filter(":even").addClass("alt");

            // sum line 
            var line = me._setListItem();
            line.item.css("border-top", "1px solid #ddd");
            line.column.append(me._setListElement("", "w7").html("<b>" + me.specific.resources.sum + "</b>"));
            line.column.append(me._setListElement("", "w5").html("<br/>"));
          
            line.column.append(me._setListElement("", "w6 text-right").html("<b>" + (Math.round(dSumC * 100) / 100) + "</b>"));


            if (me.specific.accountingMode) {
                line.column.append(me._setListElement("", "w7 text-right").html("<b>" + (Math.round(dBill * 100) / 100).toFixed(2) + "</b>"));
            }

            if (showOrderNo) {
                line.column.append(me._setListElement("", "w11 text-right").html("<br/>"));
                line.column.append(me._setListElement("", "w6 text-right").html("<br/>"));
            }


            line.column.append(me._setListElement("", "w6 text-right").html("<b>" + (Math.round(dSum * 100) / 100) + "</b>"));           


            line.column.append(me._setListElement("", "w4 text-right").html("<b>" + (Math.round(dKm * 100) / 100) + "</b>"));
            line.column.append(me._setListElement("", "w5 text-right").html("<b>" + (Math.round(dArrival * 100) / 100) + "</b>"));
            line.column.append(me._setListElement("", "w10").html("<br/>"));
            line.column.append(me._setListElement("", me.specific.accountingMode ? "w25" : "w25").html("<br/>"));

            ul.append(line.item);


          
            return true;
        } catch (ex) { me._writeErr(ex); return false }

    },


    _buildShortUserCode: function (userName) {
        /// <summary>
        /// This function builds a short user code from the given user name
        /// Example: "Mustermann, Paul" → "PMu"
        try {
            if (!userName) return "";

            // get parts of name
            const parts = userName.split(",");

            if (parts.length < 2) return userName;

            const last = parts[0].trim();   // last name
            const first = parts[1].trim();  // surname

            const firstInitial = first.charAt(0) || "";
            const lastTwo = last.substring(0, 2) || "";

            return (firstInitial + lastTwo).toUpperCase();
        } catch (ex) { me._writeErr(ex); return false }
    },

    _orderTypeNameById: function (me, id) {
        const map = objTicketActivities._getOrderTypeOptions(me);
        const k = String(id || "");
        return map[k] || "";
    },

    _getOrderTypeOptions: function (me) {
        let raw = (me.specific && me.specific.ddlOrderTypes) ? me.specific.ddlOrderTypes : "[]";
        let data = [];
        try {
            data = JSON.parse(raw);
            if (!Array.isArray(data)) data = [];
        } catch (e) { data = []; }

        // lookup for name by id
        const map = {};
        data.forEach(x => {
            if (x && x.Id != null) map[String(x.Id)] = (x.Name != null ? String(x.Name) : "");
        });

        return map;
    },



};

